<app-topbar></app-topbar>
<app-header></app-header>
<app-megamenu-new id="megamenu"></app-megamenu-new>
<app-megamenu-used id="megamenuUsed"></app-megamenu-used>
<app-megamenu-spare id="megamenuSpare"></app-megamenu-spare>
<app-megamenu-customer-service id="megamenuService"></app-megamenu-customer-service>
<app-megamenu-digital-solutions id="megamenuDigitalSolutions"></app-megamenu-digital-solutions>
<app-menu-purchase id="menuPurchase"></app-menu-purchase>
<app-menu-logos-movil id="menuCompanies"></app-menu-logos-movil>
<app-search-movil id="searchMovil"></app-search-movil>
<app-cookie></app-cookie>
<app-scroll-to-up></app-scroll-to-up>
<router-outlet />
<app-footer></app-footer>